<template>
  <!-- 任务的显示信息 -->
  <div
    class="flexshu"
    style="height: 100%; padding-left: 15px; padding-right: 15px"
  >
    <div class="task_box flexshu">
      <div class="task_tab tab_box">
        <div
          :class="[taskTabIndex == '0' ? 'task_tabActive' : 'task_tabOne']"
          @click="changeTaskTab(0)"
        >
          全部
        </div>
        <div
          :class="[taskTabIndex == '1' ? 'task_tabActive' : 'task_tabOne']"
          style="margin-left: 24px"
          @click="changeTaskTab(1)"
        >
          进行中
        </div>
        <div
          :class="[taskTabIndex == '2' ? 'task_tabActive' : 'task_tabOne']"
          style="margin-left: 24px"
          @click="changeTaskTab(2)"
        >
          已完成
        </div>
      </div>
      <div class="table-chart2" style="margin-top: 10px">
        <ul class="Info_box">
          <li
            class="Info_one"
            v-for="(task, index) in tableData"
            @click="lookDetail(task)"
            :key="index"
          >
            <div class="topInfo tab_box betw">
              <div class="tab_box">
                <!-- <img style="width:38px;height:auto;" src="../../../theme-default/src/img/SOS.png" alt=""> -->
                <div
                  class="fontYellow"
                  :class="{
                    fontBlue: task.status == '0',
                    fontGreen: task.status == '1',
                    fontRed: task.status == '2',
                    fontWhite: task.status == '3',
                  }"
                >
                  {{ task.statusTranslated }}
                </div>
                <div style="margin-left: 6px; color: #2ac1ff">
                  {{ formatDate(task.createTime) }}
                </div>
              </div>
            </div>
            <div
              class="textOver"
              style="
                color: #2ac1ff;
                font-size: 0.24rem;
                margin-top: 12px;
                text-align: left;
              "
            >
              {{ task.taskContent }}
            </div>
          </li>
        </ul>
        <div>
          <div style="position: absolute; bottom: 6rem; width: 100%; left: 0px">
            <el-pagination
              style="margin: 0 auto; display: flex; justify-content: center"
              small
              layout="prev, pager, next"
              :current-page="queryParams.pageNum"
              :page-size="queryParams.pageSize"
              @current-change="handleCurrentChange"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
      <div class="addBtn" @click="addTask">+新增任务</div>
      <el-dialog
        class="emergencyoperations-dialog normal"
        custom-class="bg3"
        top="6vh"
        :modal-append-to-body="false"
        :append-to-body="true"
        :visible.sync="isShowPop"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :destroy-on-close="true"
      >
        <NewTask
          @handlerclose="isShowPop = false"
          @newtaskcreated="newtaskcreated"
          v-bind:tableData="tableData"
        />
      </el-dialog>
      <taskDetails
        v-if="showDetail"
        @closeTaskDetail="closeTaskDetail"
        @newtaskcreated="newtaskcreated"
        v-bind:TaskId="TaskId"
        v-bind:isLookDetails="showDetail"
      ></taskDetails>
    </div>
  </div>
</template>

<script>
import MyApis from "../../../apis";
import Constant from "../config/constant";
import NewTask from "./Component-NewTask-Home";
import taskDetails from "./taskDetails";
import {
  listIntegratedTask,
  getIntegratedTaskById,
  addIntegratedTask,
  updateIntegratedTask,
} from "@/api/src/integratedTask";

export default {
  name: "HomeViewTask",
  componentName: "HomeViewTask",
  components: {
    NewTask,
    taskDetails,
  },
  dicts: ["integrated_task_status"],
  props: {},
  data() {
    return {
      ExecutId: "newtaskfortaskcenter",
      tableData: [],
      isNewtaskVisiable: false,
      msgkey: {
        emergencyFinishTaskKey:
          "MessageKey_EmergencyFinishTasknewtaskfortaskcenter",
      },

      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
      isShowPop: false,
      taskTabIndex: "0",
      showDetail: false,
      TaskId: "",
    };
  },
  created: function () {
    this.$notify.subscript(this.msgkey.emergencyFinishTaskKey, (x) =>
      this.onEmergencyFinishTaskKey(x)
    );
  },
  mounted: function () {
    this.getList();
  },
  methods: {
    newtaskcreated() {
      this.getList();
    },
    //获取任务
    getList() {
      this.loading = true;
      listIntegratedTask(this.queryParams).then((response) => {
        this.tableData = response.rows;
        this.total = parseInt(response.total);
        this.loading = false;
      });
    },
    changeTaskTab(index) {
      this.taskTabIndex = index;
      //  let param=this.msgTab[index].params

      if (index == 0) {
        this.queryParams.status = null;
      } else if (index == 1) {
        this.queryParams.status = "0";
      } else if (index == 2) {
        this.queryParams.status = "1";
      } else if (index == 3) {
        this.queryParams.status = "2";
      } else if (index == 4) {
        this.queryParams.status = "3";
      }
      this.getList();
    },
    //添加任务
    addTask() {
      this.isShowPop = true;
    },
    //查看任务详情
    lookDetail(task) {
      this.showDetail = true;
      this.TaskId = task.id;
    },
    closeTaskDetail() {
      this.showDetail = false;
    },
    //日期列表展示格式
    formatDate(date) {
      // 获取单元格数据
      let data = date;
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }

      return new Date(data).format("MM/dd hh:mm");
    },
    // 切换页码
    handleCurrentChange(val){
      this.queryParams.pageNum = val;
      this.getList();
    }
  },
};
</script>